<div class="premium-map">
  <div *ngIf="disabledMessage" role="alert" class="alert-custom alert-custom-warning d-flex align-items-center mb-0"><p class="mb-0">{{ disabledMessage }}</p></div>
  <rlst-expandable-item [title]="premiumMapLabel" [isPremium]="true" [expanded]="!disabled" [disabled]="disabled" [rlstTooltip]="disabledMessage" tooltipPosition="above">
        <div class="js-panel-header premium-header" style="display: contents;" (click)="$event.stopPropagation()">
          <div class="premium-selector">
            <div class="callout callout-default">
              <ng-template #popTemplate>
                <div [innerHtml]="popoverHtml"></div>
              </ng-template>
              <div class="callout-icon" *ngIf="{ value: isMobile$ | async } as isMobile" [popover]="popTemplate" [popoverTitle]="selectedPremiumDataElement?.label" [adaptivePosition]="isMobile.value"
                   [placement]="isMobile.value ? 'auto' : 'right bottom'" container="body" triggers="mouseenter:mouseleave">
                <div class="fa fa-info-circle"><span class="sr-only">default icon</span></div>
              </div>
            </div>
            <button [matMenuTriggerFor]="actionMenu"
                    #trigger="matMenuTrigger"
                    [ngClass]="{'open': trigger.menuOpen}"
                    type="button"
                    class="premium-trigger">
              <span *ngIf="this.selectedPremiumDataElement" class="text-ellipsis">
                {{ this.selectedPremiumDataElement.label }}
              </span>

              <i class="fa"
                 [ngClass]="{'fa-angle-up': trigger.menuOpen, 'fa-angle-down': !trigger.menuOpen}"
                 aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <span class="m-0 p-0 divider"></span>
        <fieldset class="form-group toggle-inline toggle-all-container">
          <button type="button" class="trash-icon-container" rlstTooltip="Clear Premium Map" tooltipPosition="right"
                  (click)="loadLookups()">
            <i aria-hidden="true" class="far fa-trash-alt"></i>
          </button>
          <div class="toggle-label toggle-all-label"> Toggle All </div>
          <label class="custom-control custom-toggle">
            <input type="checkbox" tabindex="0" [(ngModel)]="isToggleAllChecked" (click)="toggleAll($event)" [checked]="isToggleAllChecked"
                   class="custom-control-input ng-valid ng-dirty ng-touched toggle-primary"
                   value="isToggleAllChecked" name="exampleName" aria-labelledby="exampleId"><span tabindex="0"
                                                                                                   class="custom-control-indicator"></span><span class="custom-control-description"><span
            class="toggle-on">ON</span><span class="toggle-off">OFF</span></span></label>
        </fieldset>
        <div class="premium-toggle-options">
            <div *ngIf="!lookups" class="loading w-100" aria-hidden="true">
                <rlst-spinner-circle panelClass="spinner-small"></rlst-spinner-circle>
            </div>
            <div *ngIf="lookups?.length">
              <fieldset class="form-group toggle-inline" *ngFor="let lookupOption of lookups; let i = index">
                <div class="avatar rounded-circle avatar-xs bg-margin-common" [class]="lookupOption?.cssClass" ><span class="monospace"></span>
                </div>
                <div [ngClass]="lookupOption.labelStyleClass" class="toggle-label"> {{ lookupOption?.label }} </div>
                <label #lookupItems class="custom-control custom-toggle">
                  <input type="checkbox" tabindex="0" [checked]="lookupOption?.selected" (click)="togglePremiumOption($event, lookupOption, true)"
                         class="custom-control-input ng-valid ng-dirty ng-touched toggle-primary"
                         value="lookupOption?.code" name="exampleName" aria-labelledby="exampleId"><span tabindex="0"
                                                                                                         class="custom-control-indicator"></span><span class="custom-control-description"><span
                  class="toggle-on">ON</span><span class="toggle-off">OFF</span></span></label>
              </fieldset>
            </div>
        </div>
    </rlst-expandable-item>
</div>

<mat-menu #actionMenu="matMenu" class="premium-list">
  <button mat-menu-item *ngFor="let premiumElem of template.dataElementList" class="premium-list-item" (click)="setSelectedPremiumLayer(premiumElem)">
    {{premiumElem.label}}
  </button>
</mat-menu>
